<template>
  <div>
    <Head title="Mail Templates" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Mail Settings</li>
      </ol>
    </nav>
    <h1>Mail Inserts</h1>


      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-between mb-3">
            <Link class="btn btn-primary" href="/settings/mail/inserts/create">
              <span>Create Mail Insert</span>
            </Link>
          </div>
        </div>
        <div class="col-md-6">
          <h4>Customer</h4>
          <div class="content-box">
            <table class="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Group</th>
                  <th>Sort</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="template in inserts_customer.data" :key="template.id">
                  <td>
                    <Link :href="`/settings/mail/inserts/${template.id}/edit`">
                      {{ template.name }}
                    </Link>
                  </td>
                  <td>
                    <Link :href="`/settings/mail/inserts/${template.id}/edit`" tabindex="-1">
                      {{ template.group }}
                    </Link>
                  </td>
                  <td>
                    <Link :href="`/settings/mail/inserts/${template.id}/edit`" tabindex="-1">
                      {{ template.sort }}
                    </Link>
                  </td>
                </tr>
                <tr v-if="inserts_customer.data.length === 0">
                  <td colspan="2">No inserts found.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination class="mt-3" :links="inserts_customer.links" />
        </div>

        <div class="col-md-6">
          <h4>Operator</h4>
          <div class="content-box">
            <table class="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Group</th>
                  <th>Sort</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="template in inserts_operator.data" :key="template.id">
                  <td>
                    <Link :href="`/settings/mail/inserts/${template.id}/edit`">
                      {{ template.name }}
                    </Link>
                  </td>
                  <td>
                    <Link :href="`/settings/mail/inserts/${template.id}/edit`" tabindex="-1">
                      {{ template.group }}
                    </Link>
                  </td>
                  <td>
                    <Link :href="`/settings/mail/inserts/${template.id}/edit`" tabindex="-1">
                      {{ template.sort }}
                    </Link>
                  </td>
                </tr>
                <tr v-if="inserts_operator.data.length === 0">
                  <td colspan="2">No inserts found.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination class="mt-3" :links="inserts_operator.links" />
        </div>
      </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    customer_templates: Object,
    agency_templates: Object,
    inserts_customer: Object,
    inserts_operator: Object,
    mail_pdfs: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
